module.exports = __webpack_public_path__ + "img/m_10.7918ad0d.png";